import useResizer from "../../services/useResizer";
import React, { useEffect, useState } from "react";
import { Fab } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
export default function ScrollTopButton() {
  const [isTop, setIsTop] = useState(false);
  const list = document.getElementById("coins-list");
  const onFabClick = (event) => {
    const anchor = list;

    if (anchor) {
      if (!isTop) anchor.scrollTop = anchor.scrollHeight;
      else {
        if (window.screen.width <= 768) {
          anchor.scrollTop = 0;
          document.getElementsByTagName("html")[0].scrollTop = 0;
        } else {
          anchor.scrollTop = 0;
        }
      }
    }
  };

  function isOverflown(element) {
    return (
      element?.scrollHeight > element?.clientHeight ||
      element?.scrollWidth > element?.clientWidth
    );
  }
  function hasReachedBottom(element) {
    return element?.scrollTop == element?.scrollHeight;
  }
  function handleScroll() {
    if (list) {
      list.scrollHeight == list.offsetHeight + list.scrollTop
        ? setIsTop(true)
        : setIsTop(false);
    }
  }
  useEffect(() => {
    if (list) {
      list.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (list) list.removeEventListener("scroll", handleScroll);
    };
  }, [list]);
  return (
    isOverflown(list) && (
      <div
        className="flex justify-end mx-2 my-2 h-full items-center"
        onClick={onFabClick}
      >
        <Fab
          color="primary"
          size="small"
          aria-label="scroll back to top"
          style={{
            maxHeight: "30px",
            minHeight: "30px",
            minWidth: "30px",
            maxWidth: "30px",
          }}
        >
          {hasReachedBottom(list) ? (
            ""
          ) : (
            <KeyboardArrowDownIcon
              className={`${isTop ? "rotate-180" : ""}`}
              style={{ color: "white" }}
            />
          )}
        </Fab>
      </div>
    )
  );
}
